var _excluded = ["className", "size", "checked", "disabled", "onChange", "onValueChange", "children", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useRef, useMemo } from 'react';
import { classnames } from '@okee-uikit/react-utils';
import { useDirection, usePrefixCls, usePropsDefault } from '@okee-uikit/react-config';
import { CheckWrapper } from '../../units/check-wrapper';
export function Radio(props) {
  var propsDefault = usePropsDefault('Radio');

  var _propsDefault$props = _objectSpread(_objectSpread({}, propsDefault), props),
      className = _propsDefault$props.className,
      _propsDefault$props$s = _propsDefault$props.size,
      size = _propsDefault$props$s === void 0 ? 'md' : _propsDefault$props$s,
      _propsDefault$props$c = _propsDefault$props.checked,
      checked = _propsDefault$props$c === void 0 ? false : _propsDefault$props$c,
      _propsDefault$props$d = _propsDefault$props.disabled,
      disabled = _propsDefault$props$d === void 0 ? false : _propsDefault$props$d,
      onChange = _propsDefault$props.onChange,
      onValueChange = _propsDefault$props.onValueChange,
      children = _propsDefault$props.children,
      variant = _propsDefault$props.variant,
      extra = _objectWithoutProperties(_propsDefault$props, _excluded);

  var variantObj = useMemo(function () {
    if (!(variant === null || variant === void 0 ? void 0 : variant.length)) return {};
    var variants = {
      variant: true
    };
    variant === null || variant === void 0 ? void 0 : variant.forEach(function (element) {
      variants['variant-' + element] = true;
    });
    return variants;
  }, [variant]);
  var rtl = useDirection() === 'rtl';
  var ref = useRef(null);
  var cls = classnames(usePrefixCls('radio', _objectSpread({
    size: size,
    checked: checked,
    disabled: disabled,
    rtl: rtl
  }, variantObj)), className);
  var circleCls = usePrefixCls('radio-circle', {
    size: size
  });
  var labelCls = usePrefixCls('radio-label');
  return React.createElement(CheckWrapper, _objectSpread(_objectSpread({}, extra), {}, {
    type: "radio",
    className: cls,
    checked: checked,
    disabled: disabled,
    onChange: onChange,
    onValueChange: onValueChange,
    waveElementRef: ref
  }), !(variant === null || variant === void 0 ? void 0 : variant.length) && React.createElement("span", {
    className: circleCls,
    ref: ref
  }), !!children && React.createElement("span", {
    className: labelCls
  }, children));
}